import { css, Rule } from 'glamor'
import * as React from 'react'
import * as PropTypes from 'prop-types'

import { useTheme } from '../../theme'

import getStyles from './styles'

interface IInputGroupProps {
  children?: React.ReactNode
  flush?: boolean
  style?: Rule
}

export const InputGroup = ({ children, flush, style }: IInputGroupProps) => {
  const styles = getStyles(useTheme())
  return <div {...css([styles.group.base, flush && styles.group.flush, style])}>{children}</div>
}

InputGroup.displayName = 'InputGroup'

InputGroup.propTypes = {
  children: PropTypes.node,
  flush: PropTypes.bool,
  style: PropTypes.object,
}
